import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar navbar-primary bg-primary text-secondary" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "container-fluid" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "navbar-brand",
    href: "#"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://fontmeme.com/permalink/220303/53e6f4184809d9dbe6e98062a0948a4e.png",
      alt: "vue-pokedex",
      width: "120"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, _hoisted_3))
}